import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CondominioTrocaPageRoutingModule } from './condominio-troca-routing.module';

import { CondominioTrocaPage } from './condominio-troca.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CondominioTrocaPageRoutingModule
  ],
  declarations: [CondominioTrocaPage]
})
export class CondominioTrocaPageModule {}
